import Api from '@/services/Api'

class StatusService {
  status () {
    return Api().get('status')
  }
}

export default new StatusService()
